export type Storage<T> = {
  getItem: (key: T) => string | null;
  setItem: (key: T, value: string) => void;
  removeItem: (key: T) => void;
};

export type AuthStore = {
  accessToken?: string;
  refreshToken?: string;
};

type AuthStoreKey = keyof AuthStore;

export class TokenStore implements Storage<AuthStoreKey> {
  private readonly store: AuthStore;

  constructor() {
    this.store = {
      accessToken: '',
      refreshToken: '',
    };
  }

  public getItem(key: AuthStoreKey): string | null {
    return this.store[key] || null;
  }

  public setItem(key: AuthStoreKey, value: string): void {
    this.store[key] = value;
  }

  public removeItem(key: AuthStoreKey): void {
    delete this.store[key];
  }

  public clear(): void {
    this.store.accessToken = '';
    this.store.refreshToken = '';
  }
}
